<template>
  <div class="rating">
    <div class="rating-container">
      <div>
        <h1 class="title">{{ t('rating_title') }}</h1>
        <p class="transcript-email" v-if="email" v-html="t('transcript_messages_done', { email })"/>
        <p class="intro">{{ t('rating_messages_intro') }}</p>
        <div class="form-container">
          <StarRate
            v-model="rating.star"
            hover-change
            :on-change="onChangeRating"
          >
            <Icon :art="'light'" :name="'star'" :color="'darkgray'" slot="customInactive" slot-scope="props" :class="props.computeClass" />
            <Icon :art="'regular'" :name="'star'" :color="'#5bac26'" slot="customHover" slot-scope="props" :class="props.computeClass" />
            <Icon :art="'solid'" :name="'star'" :color="'#5bac26'" slot="customActive" slot-scope="props" :class="props.computeClass" />
          </StarRate>
          <textarea
            rows="3"
            class="comment"
            name="input-rating"
            maxlength="255"
            :placeholder="t('rating_placeholder')"
            v-model="rating.comment"
            @input="onChangeRating"
          />
          <small class="comment-counter">{{ rating.comment.length }} / 255</small>
        </div>
      </div>
      <div class="buttons-container" :class="$mqAliases.isMobile ? 'mobile-buttons' : ''">
        <ChatButton
          class="sanitas-button yes"
          :types="['primary']"
          @click="sendHelpfulRating"
        >
          {{ t('rating_buttons_yes') }}
        </ChatButton>
        <ChatButton
          class="sanitas-button no"
          :types="['primary']"
          @click="sendNotHelpfulRating"
        >
          {{ t('rating_buttons_no') }}
        </ChatButton>
      </div>
    </div>
  </div>
</template>

<script>
import StarRate from './rating/StarRate'
import { useI36n } from '@jota-one/i36n/src/index.vue2'
import { mapActions, mapGetters, mapState } from 'vuex'
import ChatButton from './ChatButton'
import Icon from './Icon'

export default {
  name: 'rating',
  components: {
    ChatButton,
    StarRate,
    Icon
  },

  setup () {
    const { $label: t } = useI36n()

    return { t }
  },

  data () {
    return {
      rating: {
        star: null,
        comment: '',
        answer: true
      }
    }
  },
  computed: {
    ...mapGetters('conversation', { agent: 'getLatestAgent', getRating: 'getRating' }),
    ...mapGetters('uistate', ['webView']),
    ...mapState('conversation', ['conversation']),
    email: {
      get () {
        return this.$store.state.uistate.transcriptEmail
      },
      set (value) {
        this.$store.commit('uistate/SET_TRANSCRIPT_EMAIL', value)
      }
    }
  },
  created () {
    this.rating = {
      ...this.getRating
    }
  },
  methods: {
    ...mapActions('conversation', ['setRating']),
    onChangeRating () {
      this.setRating(this.rating)
    },
    sendHelpfulRating () {
      this.$store.dispatch('conversation/sendRating', this.rating)
      this.email = ''
    },
    sendNotHelpfulRating () {
      this.rating.answer = false
      this.setRating(this.rating)
      this.$store.dispatch('conversation/sendRating', this.rating).then(() => {
        this.$store.commit('uistate/SET_CONVERSATION_STATE', 'CONVERSATION_RATED')
        this.email = ''
      })
    }
  }
}
</script>

<style scoped lang="postcss">
.rating {
  overflow: auto;
  height: 100%;
  box-shadow: 0 6px 6px -3px rgba(0,0,0,0.2), 0 10px 14px 1px rgba(0,0,0,0.14), 0 4px 18px 3px rgba(0,0,0,0.12);
  padding: 15px;
  background-color: white;

  &-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    height: 100%;

    .title {
      word-break: break-all;
      margin: 50px 15px 20px 15px;
      text-align: center;
      background-color: #fff;
      font-family: 'Open Sans', sans-serif;
      font-size: 25px;
      font-weight: bold;
      line-height: 1.2;
      color: #191919;
    }
    .intro {
      text-align: left;
      padding: 0 40px;
      font-family: 'Open Sans', sans-serif;
      font-size: 15px;
      line-height: 1.33;
      color: #191919;
    }
    .transcript-email {
      color: #191919;
      word-break: break-word;
      padding: 0 40px 5px;
    }
  }
  .form-container {
    background-color: white;
    margin: 15px 15px 0;
    text-align: center;

    svg {
      height: 18px;
      width: 18px;
    }
    p {
      color: #a2a4a5;
    }
    .star-main {
      margin: 0;
    }
    .comment {
      border-top: none;
      border-right: none;
      border-bottom: 1px solid #191919;
      border-left: none;
      margin-top: 30px;
      resize: none;
      outline: none;
      font-size: 15px;
      line-height: 1.33;
      width: 100%;
      height: 200px;
      padding: 5px 10px 155px;
      background-color: #f3f2f0;
      color: #000;
    }
    .comment-counter {
      float: right;
      margin-bottom: 30px;
    }
  }
  .buttons-container {
    align-self: end;
    padding: 0 15px;
    width: 100%;

    .sanitas-button {
      border-radius: 25px;
      height: 50px;
      width: 100%;
    }
  }
  .mobile-buttons {
    width: 100%;
    margin-top: auto;
  }
}
</style>
